const isInputElement = (element: Element): element is HTMLInputElement => {
    return element.tagName.toLowerCase() === 'input';
};

export default isInputElement;
